import {
  Thumbnail,
} from 'API';
import { Picture, S3Object } from 'models';

class PictureService {
  /**
   * Given a Picture object, see if a desired thumbnail is available.
   * If so, return the thumbnail.
   * If not, return the original.
   *
   * @param {Picture} picture - Picture option with original and possible
   *                            thumbnails
   * @param {number} target - Desired width
   * @param {boolean} square - Whether square is desired
   * @returns
   */
  targetPictureSize = (
    picture: Picture,
    target: number,
    square?: boolean,
  ): S3Object => {
    let thumbnail: Thumbnail | undefined;

    if (square && picture.squareThumbnails) {
      thumbnail = picture.squareThumbnails.find(
        (thumb) => thumb.size === target,
      ) as Thumbnail;
    } else if (picture.thumbnails) {
      thumbnail = picture.thumbnails.find(
        (thumb) => thumb.size === target,
      ) as Thumbnail;
    }

    if (thumbnail?.image) {
      return thumbnail.image as S3Object;
    }

    if (square) {
      return (picture.square || picture.original) as S3Object;
    }

    return picture.original as S3Object;
  };
}

export default new PictureService();
